// import React, { useState } from "react";

// const ChangeRequestForm = ({
//   formData,
//   errors,
//   handleChange,
//   handleSubmit,
// }) => {
//   const [isDropdownOpen, setIsDropdownOpen] = useState(false);
//   const [selectedValues, setSelectedValues] = useState([]);

//   const options = [
//     { id: 1, name: "Address Change" },
//     { id: 2, name: "Address Adition" },
//     { id: 3, name: "Contact Adition" },
//     { id: 4, name: "Contact Deactivate" },
//     { id: 5, name: "Contact Details Update" },
//   ];

//   const toggleDropdown = () => setIsDropdownOpen((prev) => !prev);

//   const handleSelectionChange = (value) => {
//     setSelectedValues((prev) =>
//       prev.includes(value)
//         ? prev.filter((item) => item !== value)
//         : [...prev, value]
//     );
//   };

//   return (
//     <form onSubmit={handleSubmit} className="space-y-4">
//       {/* Channel Partner */}
//       <div>
//         <label htmlFor="accountId" className="block mb-2 font-semibold">
//           Channel Partner <span className="text-red-500">*</span>
//         </label>
//         <input
//           id="accountId"
//           name="Account_id"
//           value={formData.Account_id}
//           onChange={handleChange}
//           className={`border rounded-md p-2 w-full ${
//             errors.Account_id ? "border-red-500" : "border-gray-300"
//           }`}
//         />
//         {errors.Account_id && (
//           <p className="text-red-500">{errors.Account_id}</p>
//         )}
//       </div>

//       {/* Request For */}
//       <div>
//         <label htmlFor="requestFor" className="block mb-2 font-semibold">
//           Request For <span className="text-red-500">*</span>
//         </label>
//         <div className="relative">
//           <button
//             type="button"
//             className="w-full py-2 px-4 border rounded-lg bg-white text-left"
//             onClick={toggleDropdown}
//           >
//             {selectedValues.length > 0
//               ? selectedValues.join(", ")
//               : "Select options..."}
//           </button>
//           {isDropdownOpen && (
//             <div className="absolute w-full mt-2 bg-white border rounded-lg shadow-md max-h-40 overflow-y-auto z-10">
//               {options.map((option) => (
//                 <div
//                   key={option.id}
//                   className="cursor-pointer px-4 py-2 flex items-center hover:bg-gray-100"
//                   onClick={() => handleSelectionChange(option.name)}
//                 >
//                   <input
//                     type="checkbox"
//                     checked={selectedValues.includes(option.name)}
//                     readOnly
//                     className="mr-2"
//                   />
//                   {option.name}
//                 </div>
//               ))}
//             </div>
//           )}
//         </div>
//       </div>

//       {/* Remarks */}
//       <div>
//         <label htmlFor="remarks" className="block mb-2 font-semibold">
//           Remarks <span className="text-red-500">*</span>
//         </label>
//         <textarea
//           id="remarks"
//           name="remarks"
//           value={formData.remarks || ""}
//           onChange={handleChange}
//           className={`border rounded-md p-2 w-full ${
//             errors.remarks ? "border-red-500" : "border-gray-300"
//           }`}
//         />
//         {errors.remarks && <p className="text-red-500">{errors.remarks}</p>}
//       </div>

//       {/* Submit Button */}
//       <div className="flex justify-center mt-4">
//         <button
//           type="submit"
//           className="bg-blue-500 text-white py-2 px-6 rounded-lg hover:bg-blue-600"
//         >
//           Submit
//         </button>
//       </div>
//     </form>
//   );
// };

// export default ChangeRequestForm;


import React, { useEffect, useRef, useState } from "react";

const ChangeRequestForm = ({ formData, errors, handleChange, handleSubmit }) => {
  const dropdownRef = useRef(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const options = [
    { id: 1, name: "Address Change" },
    { id: 2, name: "Address Addition" },
    { id: 3, name: "Contact Addition" },
    { id: 4, name: "Contact Deactivate" },
    { id: 5, name: "Contact Details Update" },
  ];

  const toggleDropdown = () => setIsDropdownOpen((prev) => !prev);

  const handleSelectionChange = (value) => {
    const updatedValues = formData.selectedValues.includes(value)
      ? formData.selectedValues.filter((item) => item !== value)
      : [...formData.selectedValues, value];

    handleChange({ target: { name: "selectedValues", value: updatedValues } });
  };


   // Close dropdown when clicking outside
   useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []); 

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      {/* Channel Partner */}
      <div>
        <label htmlFor="accountId" className="block mb-2 font-semibold">
          Channel Partner <span className="text-red-500">*</span>
        </label>
        <input
          id="accountId"
          name="Account_id"
          value={formData.Account_id}
          disabled
          onChange={handleChange}
          className={`border rounded-md p-2 w-full cursor-not-allowed ${
            errors.Account_id ? "border-red-500" : "border-gray-300"
          }`}
        />
        {errors.Account_id && (
          <p className="text-red-500">{errors.Account_id}</p>
        )}
      </div>

      {/* Request For */}
      <div>
        <label htmlFor="requestFor" className="block mb-2 font-semibold">
          Request For <span className="text-red-500">*</span>
        </label>
        <div className="relative" ref={dropdownRef}>
          <button
            type="button"
            className="w-full py-2 px-4 border rounded-lg bg-white text-left"
            onClick={toggleDropdown}
          >
            {formData.selectedValues.length > 0
              ? formData.selectedValues.join(", ")
              : "Select options..."}
          </button>
          {isDropdownOpen && (
            <div className="absolute w-full mt-2 bg-white border rounded-lg shadow-md max-h-40 overflow-y-auto z-10">
              {options.map((option) => (
                <div
                  key={option.id}
                  className="cursor-pointer px-4 py-2 flex items-center hover:bg-gray-100"
                  onClick={() => handleSelectionChange(option.name)}
                >
                  <input
                    type="checkbox"
                    checked={formData.selectedValues.includes(option.name)}
                    readOnly
                    className="mr-2"
                  />
                  {option.name}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* Remarks */}
      <div>
        <label htmlFor="remarks" className="block mb-2 font-semibold">
          Remarks <span className="text-red-500">*</span>
        </label>
        <textarea
          id="remarks"
          name="remarks"
          value={formData.remarks}
          onChange={handleChange}
          className={`border rounded-md p-2 w-full ${
            errors.remarks ? "border-red-500" : "border-gray-300"
          }`}
        />
        {errors.remarks && <p className="text-red-500">{errors.remarks}</p>}
      </div>

      {/* Submit Button */}
      <div className="flex justify-center mt-4">
        <button
          type="submit"
          className="bg-blue-500 text-white py-2 px-6 rounded-lg hover:bg-blue-600"
        >
          Submit
        </button>
      </div>
    </form>
  );
};

export default ChangeRequestForm;
